<template>
  <div>
    <div v-if="showSearch" class="mb-8 flex rounded border border-gray-mid px-4 py-2">
      <div class="mr-2 mt-1">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5879 11.7377C9.50049 12.5312 8.1571 13 6.70322 13C3.08096 13 0.144531 10.0899 0.144531 6.5C0.144531 2.91015 3.08096 0 6.70322 0C10.3255 0 13.2619 2.91015 13.2619 6.5C13.2619 7.92729 12.7977 9.24714 12.0108 10.3194L16.2986 14.6382L14.8601 16.0409L10.5879 11.7377ZM11.2439 6.5C11.2439 8.98528 9.21094 11 6.70322 11C4.1955 11 2.16259 8.98528 2.16259 6.5C2.16259 4.01472 4.1955 2 6.70322 2C9.21094 2 11.2439 4.01472 11.2439 6.5Z" fill="#808080" />
        </svg>
      </div>
      <input v-model="query" type="text" class="w-full pt-0.5 focus:outline-none" :placeholder="searchPlaceholder">
    </div>

    <div class="justify-between md:flex">
      <div v-for="(column, idx) in columns" :key="idx" class="grow md:first:mr-4">
        <div v-for="item in column" :key="item.item.id" class="mb-2">
          <Checkbox :model-value="item.item.id" :checked="shouldBeChecked(item.item.id)" @change="updateVals">
            <span class="leading-snug">
              <span v-html="highlightName(item)" />
              <span v-if="item.item.count">({{ item.item.count }})</span>
            </span>
          </Checkbox>
        </div>
      </div>
    </div>
    <div>
      <a v-if="filtered.length > showNumber && !showMore" href="#" class="letter-sp15 mt-4 inline-flex items-center uppercase" @click.stop.prevent="showMore = true">
        Show more
        <img src="~/assets/images/icons/arrow-bottom.svg" class="-mt-px ml-3">
      </a>
    </div>
  </div>
</template>

<script>
import Fuse from 'fuse.js'
import fuseHighlight from '../../utils/fuse-highlight'
import Checkbox from './Checkbox'

export default {
  components: { Checkbox },

  props: {
    items: { type: Array, required: true },
    modelValue: { type: Array, required: true },
    cols: { type: Number, default: 2 },
    showSearch: { type: Boolean, default: true },
    searchPlaceholder: { type: String, default: 'Search' },
    showNumber: { type: Number, default: 24 },
  },

  emits: ['update:modelValue'],

  data: () => ({
    query: '',
    fuse: null,
    showMore: false,
  }),

  computed: {
    columns () {
      return this.limited.reduce((acc, el, idx) => {
        if (! acc[idx % this.cols]) { acc[idx % this.cols] = [] }
        acc[idx % this.cols].push(el)
        return acc
      }, [])
    },

    limited () {
      if (this.showMore || this.filtered.length <= this.showNumber) {
        return this.filtered
      }

      return this.filtered.slice(0, this.showNumber)
    },

    filtered () {
      if (! this.query) {
        return this.items.map(i => ({ item: i }))
      }

      return this.fuse.search(this.query)
    },
  },

  watch: {
    items () {
      this.initFuse()
    },
  },

  beforeMount () {
    this.initFuse()
  },

  methods: {
    initFuse () {
      this.fuse = new Fuse(this.items, {
        includeMatches: true,
        threshold: 0.3,
        keys: ['name'],
      })
    },

    shouldBeChecked (val) {
      return this.modelValue.includes(`${val}`)
    },

    updateVals (e) {
      const isChecked = e.target.checked
      const val = e.target.value
      const newValue = Object.assign([], this.modelValue)

      if (isChecked) {
        newValue.push(val)
      } else {
        newValue.splice(newValue.indexOf(val), 1)
      }

      this.$emit('update:modelValue', newValue)
    },

    highlightName (item) {
      if (! item.matches) { return item.item.name }

      const highlights = fuseHighlight(item, '<span class="bg-blue bg-opacity-10">', '</span>')

      return highlights.name
    },
  },
}
</script>
